export const TEMPLATE_CATEGORIES = [
  'Corporate',
  'Coaching',
  'Business',
  'Sale',
  'Fashion',
  'Creator',
  'Ecommerce',
  'Education',
  'Finance',
  'Freelancer',
  'Local Services',
  'Manufacturing',
  'Medicine',
  'Nonprofit',
  'Real Estate',
  'Software',
  'Startup',
  'Travel',
  'Event',
  'Love',
  'Beauty',
  'Greeting',
]

export const TEMPLATE_TYPES = {
  quote: 'Quote',
  illustration: 'Illustration',
  photo: 'Photo',
  collage: 'Collage',
  announcement: 'Announcement',
  video: 'Video',
  'social media': 'Social Media',
  marketplace: 'Marketplace',
  tools: 'Tools',
  docs: 'Docs',
  ads: 'Ads',
  emails: 'Emails',
  'product descriptions': 'Product Descriptions',
  website: 'Website',
  sales: 'Sales',
}

export const TEMPLATE_STYLES = {
  modern: 'Modern',
  minimalist: 'Minimalist',
  simple: 'Simple',
  professional: 'Professional',
  corporate: 'Corporate',
  elegant: 'Elegant',
  creative: 'Creative',
  colorful: 'Colorful',
  aesthetic: 'Aesthetic',
  promotional: 'Promotional',
  feminine: 'Feminine',
  clean: 'Clean',
}
